import { createSubscribableSelector } from './createSubscribableSelector';

/**
 * Создает подписку на значение переданного селектора:
 * 1. Вызовы `selector` происходят при изменениях в любом из задействованных сторов
 * 2. Первый вызов `callback(value)` происходит синхронно
 * 3. Последующие вызовы `callback(value)` происходят при изменении возвращаемого значения `selector`
 *
 * @param selector Селектор, за изменениями значения которого нужно следить
 * @param callback Функция, вызываемая при изменениях значения селектора
 * @returns Функция `unsubscribe`, которая удалит созданную подписку
 */
export function subscribeToSelector<Returned>(selector: () => Returned, callback: (selectedValue: Returned) => void) {
    const { select, subscribeToSelector, subscribeToStores } = createSubscribableSelector(selector);
    const unsubscribeStores = subscribeToStores();

    let previousSelectedValue = select();

    const unsubscribeCallback = subscribeToSelector(() => {
        const selectedValue = select();

        if (selectedValue !== previousSelectedValue) {
            previousSelectedValue = selectedValue;
            callback(selectedValue);
        }
    });

    callback(previousSelectedValue);

    return function unsubscribeFromSelector() {
        unsubscribeStores();
        unsubscribeCallback();
    };
}
